
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { CreateElement } from 'vue'

@Component
export default class QuillDelta extends Vue {
  @Prop({ default: false })
  readonly plain!: boolean

  render(h: CreateElement) {
    const text = this.$slots!.default![0].text!.trim()

    try {
      const converter = new QuillDeltaToHtmlConverter(JSON.parse(text), {
        inlineStyles: true
      })
      const html = converter.convert()

      if (this.plain) {
        return h(
          'article',
          {
            domProps: {
              innerText: html.replace(/(<([^>]+)>)/gi, '')
            },
            style: {
              'line-height': 'initial'
            }
          },
          []
        )
      } else {
        return h(
          'article',
          {
            domProps: {
              innerHTML: html
            },
            style: {
              'line-height': 'initial'
            }
          },
          []
        )
      }
    } catch (err) {
      return h(
        'article',
        {
          domProps: {
            innerText: text
          }
        },
        []
      )
    }
  }
}
